import './index.css';
import App from './App';
import React from 'react';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
